;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import Text from 'components/ui/Text';

import styles from './ProductList.module.scss';

const ProductList = ({ data = [] }) => {
    return (
        <div className={styles.root}>
            {data.map((product, idx) => {
                return (
                    <dl
                        key={`product-list-${idx}`}
                        className={styles.list}
                        style={{
                            '--product-list-columns':
                                Object.keys(product).length,
                        }}
                    >
                        {Object.entries(product).map(([key, value], index) => (
                            <div
                                key={`product-detail-${idx}-${index}`}
                                className={styles.group}
                            >
                                <dt>
                                    <Text baseTheme="labelMedium">{key}</Text>
                                </dt>
                                <dd>
                                    <Text baseTheme="bodySmall">{value}</Text>
                                </dd>
                            </div>
                        ))}
                    </dl>
                );
            })}
        </div>
    );
};

ProductList.propTypes = {
    data: PropTypes.array,
};

export default ProductList;
